"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PythAdapter = void 0;
const pyth_evm_js_1 = require("@pythnetwork/pyth-evm-js");
const viem = __importStar(require("viem"));
class PythAdapter {
    constructor(endpoint) {
        this.connection = new pyth_evm_js_1.EvmPriceServiceConnection(endpoint);
    }
    getOracleId() {
        return 'PYTH';
    }
    async fetchOffchainData(_client, _requester, data) {
        const [updateType] = viem.decodeAbiParameters([{ name: 'updateType', type: 'uint8' }], data);
        if (updateType === 1) {
            const [updateType, stalenessOrTime, priceIds] = viem.decodeAbiParameters([
                { name: 'updateType', type: 'uint8' },
                { name: 'stalenessTolerance', type: 'uint64' },
                { name: 'priceIds', type: 'bytes32[]' },
            ], data);
            const stalenessTolerance = stalenessOrTime;
            let updateData = (await this.connection.getPriceFeedsUpdateData(priceIds));
            return viem.encodeAbiParameters([
                { type: 'uint8', name: 'updateType' },
                { type: 'uint64', name: 'stalenessTolerance' },
                { type: 'bytes32[]', name: 'priceIds' },
                { type: 'bytes[]', name: 'updateData' },
            ], [updateType, stalenessTolerance, priceIds, updateData]);
        }
        else if (updateType === 2) {
            const [updateType, requestedTime, priceId] = viem.decodeAbiParameters([
                { name: 'updateType', type: 'uint8' },
                { name: 'requestedTime', type: 'uint64' },
                { name: 'priceIds', type: 'bytes32' },
            ], data);
            const [priceFeedUpdateVaa] = await this.connection.getVaa(priceId, Number(requestedTime.toString()));
            const priceFeedUpdate = '0x' + Buffer.from(priceFeedUpdateVaa, 'base64').toString('hex');
            return viem.encodeAbiParameters([
                { type: 'uint8', name: 'updateType' },
                { type: 'uint64', name: 'timestamp' },
                { type: 'bytes32[]', name: 'priceIds' },
                { type: 'bytes[]', name: 'updateData' },
            ], [updateType, requestedTime, [priceId], [priceFeedUpdate]]);
        }
        else {
            throw new Error(`update type ${updateType} not supported`);
        }
    }
}
exports.PythAdapter = PythAdapter;
//# sourceMappingURL=pyth.js.map